import React, { Children } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid2';

export default function LoginFormFooterGrid({ children }) {
  const items = Children.toArray(children);

  return (
    (<Grid container justifyContent="flex-end">
      <Grid
        size={{
          sm: 4,
          xs: 12
        }}>
        {items[0]}
      </Grid>
    </Grid>)
  );
}

LoginFormFooterGrid.propTypes = {
  children: PropTypes.node,
};
